export const urgencyPointTexts = [
  { key: "discount", text: "500€ HT de remise immédiate" },
  { key: "slots", textFn: (slots) => `Plus que ${slots} place${slots > 1 ? 's' : ''} cette semaine !` },
  { key: "response", text: "Réponse rapide sous 24h" }
];

export const benefits = [
  {
    iconName: "Eye",
    title: "Attirez plus de clients",
    description: "Une enseigne visible multiplie par 3 le nombre de visiteurs potentiels.",
    image: "https://images.pexels.com/photos/8919461/pexels-photo-8919461.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    iconName: "TrendingUp",
    title: "Améliorez votre image",
    description: "Professionnalisez votre devanture et inspirez confiance instantanément.",
    image: "https://images.pexels.com/photos/2448672/pexels-photo-2448672.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    iconName: "BadgeEuro",
    title: "Rentabilisez votre local",
    description: "Investissement amorti en quelques mois grâce à l'augmentation du trafic.",
    image: "https://images.unsplash.com/photo-1721761961411-8d9a578eb246?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxuZW9uJTIwc2lnbiUyMHNob3B8ZW58MHx8fHwxNzc0NjQ1NDkxfDA&ixlib=rb-4.1.0&q=85"
  }
];

export const stats = [
  { value: "500+", label: "enseignes posées" },
  { value: "24h", label: "délai de réponse" },
  { value: "10 ans", label: "garantie décennale" }
];

export const clientLogos = [
  { 
    name: "Nos clients", 
    logo: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/b3w6hrr9_logos.png",
    wide: true 
  }
];

export const testimonials = [
  {
    name: "Marie D.",
    business: "Boulangerie Le Pain Doré",
    location: "Paris 15e",
    text: "Excellente prestation ! L'enseigne a transformé ma vitrine. Je reçois beaucoup plus de clients depuis l'installation.",
    rating: 5
  },
  {
    name: "Thomas R.",
    business: "Restaurant Le Comptoir",
    location: "Lyon",
    text: "Équipe très professionnelle, respect des délais et qualité irréprochable. Je recommande vivement !",
    rating: 5
  },
  {
    name: "Sophie M.",
    business: "Salon Beauté & Bien-être",
    location: "Marseille",
    text: "La simulation m'a permis de visualiser exactement le rendu final. Aucune surprise, c'est parfait !",
    rating: 5
  }
];

export const pricing = [
  {
    name: "Lettres Découpées",
    description: "PVC, Alu ou Inox",
    priceRange: "800€ - 2 500€",
    features: ["Lettres sur mesure", "Pose incluse", "Garantie 5 ans"],
    popular: false
  },
  {
    name: "Enseigne Lumineuse",
    description: "LED rétro-éclairé",
    priceRange: "1 500€ - 4 500€",
    features: ["Lettres LED", "Faible consommation", "Garantie 10 ans"],
    popular: true
  },
  {
    name: "Caisson Lumineux",
    description: "Grand format",
    priceRange: "2 500€ - 6 000€",
    features: ["Visibilité maximale", "Design personnalisé", "Garantie 10 ans"],
    popular: false
  },
  {
    name: "Enseigne Néon",
    description: "Style vintage ou moderne",
    priceRange: "1 200€ - 3 500€",
    features: ["Effet néon LED", "Couleurs au choix", "Garantie 5 ans"],
    popular: false
  }
];

export const guarantees = [
  { iconName: "ShieldCheck", text: "Garantie décennale" },
  { iconName: "Award", text: "Artisan qualifié" },
  { iconName: "Wrench", text: "SAV réactif" },
  { iconName: "Check", text: "Devis gratuit" }
];

export const portfolio = [
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/bpect40m_WhatsApp%20Image%202026-03-27%20at%2017.55.53.jpeg",
    name: "Crousty Game",
    type: "Succès du moment - Style pixel LED"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/7orxo3od_WhatsApp%20Image%202026-03-27%20at%2017.55.53.jpeg",
    name: "Madame B",
    type: "Lettres rétro-éclairées"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/ycolesdx_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%282%29.jpeg",
    name: "La Grande Pharmacie",
    type: "Enseigne végétale"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/2do1h3x4_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%288%29.jpeg",
    name: "Kebap Haus",
    type: "Lettres lumineuses dorées"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/7iamksl2_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%285%29.jpeg",
    name: "Mikado Home",
    type: "Caisson lumineux LED"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/o0i7ljaz_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%286%29.jpeg",
    name: "Assemblée Générale Café",
    type: "Lettres découpées PVC"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/fmxk5dma_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%289%29.jpeg",
    name: "H.market",
    type: "Lettres découpées alu"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/0a2u4e2y_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%2810%29.jpeg",
    name: "Waffle Factory",
    type: "Enseigne lumineuse grand format"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/lhba0uiu_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%2813%29.jpeg",
    name: "La Bonne Fourchette",
    type: "Bandeau lumineux + lettres"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/yd7ej5vd_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%2811%29.jpeg",
    name: "#CHB Chicken House",
    type: "Lettres LED bicolores"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/bgrhuqa4_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%2812%29.jpeg",
    name: "L'Agence",
    type: "Lettres lumineuses premium"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/9h41ohie_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%288%29.jpeg",
    name: "Le Safari",
    type: "Logo lumineux + lettres sculptées"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/2d4q9hws_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%287%29.jpeg",
    name: "Point B",
    type: "Lettres suspendues bicolores"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/1w456meq_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%286%29.jpeg",
    name: "Big M",
    type: "Enseigne centre commercial + néon"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/va4mnd6g_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%2810%29.jpeg",
    name: "Campus 113",
    type: "Lettres volumiques grand format"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/jyfl6rqm_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%289%29.jpeg",
    name: "Woodbrass Music",
    type: "Caisson lumineux bleu"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/sw1yp50d_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%282%29.jpeg",
    name: "Royal Palace",
    type: "Pose nacelle + lettres façade"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/aaxs7jpx_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%281%29.jpeg",
    name: "Poulet Braisé",
    type: "Lettres volumiques bicolores"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/w5ljepov_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%285%29.jpeg",
    name: "Chicken Point",
    type: "Logo + lettres rétro-éclairées"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/5vraw3cn_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%284%29.jpeg",
    name: "Chicken Point",
    type: "Façade complète angle de rue"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/8kpqhlf3_WhatsApp%20Image%202026-03-27%20at%2017.55.53%20%283%29.jpeg",
    name: "Pharmacie Leader",
    type: "Bandeau lumineux LED"
  }
];

export const configuratorOptions = {
  types: [
    { id: "lettres", name: "Lettres Découpées", basePrice: 800, image: "https://customer-assets.emergentagent.com/job_5d6c732c-cf1e-405b-b1e0-8e2f48f16344/artifacts/zdklpfoi_image.png" },
    { id: "led", name: "Enseigne LED", basePrice: 1500, image: "https://customer-assets.emergentagent.com/job_devanture-clients/artifacts/5w9x3l3a_image.png" },
    { id: "caisson", name: "Caisson Lumineux", basePrice: 2500, image: "https://customer-assets.emergentagent.com/job_5d6c732c-cf1e-405b-b1e0-8e2f48f16344/artifacts/87hxjr86_image.png" },
    { id: "neon", name: "Néon LED", basePrice: 1200, image: "https://customer-assets.emergentagent.com/job_5d6c732c-cf1e-405b-b1e0-8e2f48f16344/artifacts/tb47ni8d_image.png" }
  ],
  sizes: [
    { id: "small", name: "Petite (1-3m)", multiplier: 0.7 },
    { id: "medium", name: "Moyenne (3-6m)", multiplier: 1.0 },
    { id: "large", name: "Grande (6-12m)", multiplier: 1.5 }
  ],
  materials: [
    { id: "pvc", name: "PVC", multiplier: 1.0 },
    { id: "alu", name: "Aluminium", multiplier: 1.3 },
    { id: "inox", name: "Inox", multiplier: 1.6 }
  ],
  colors: [
    { id: "standard", name: "Couleur standard", multiplier: 1.0 },
    { id: "custom", name: "Couleur personnalisée", multiplier: 1.15 }
  ]
};

export const WHATSAPP_NUMBER = "33643693688";
